// ----------------------------------------------------------------------

export const paths = {
  // Common
  root: '/',
  ucsnq: '/ucsnq',
  snq: '/snq',
  snq_component: '/component',
  catalog: '/qualifications',
  catalog_details: '/qualification/:id/details',
  equivalency: '/equivalency',
  rvcc: '/rvcc',
  square: '/square',
  document: '/documents',
  news: '/news',
  news_details: '/new/:id/details',
  contact: '/contact',
  page404: '/404',
  page500: '/500',

  // Others
  pages: '/pages',
  docs: 'https://zone-docs.vercel.app',
  license: 'https://material-ui.com/store/license/#i-standard-license',
  minimalStore: 'https://material-ui.com/store/items/minimal-dashboard',
  zoneStore: 'https://mui.com/store/items/zone-landing-page/',
  figmaPreview:
    'https://www.figma.com/file/X6OyiGHF8dnTk3aT38P0oN/%5BPreview%5D-Zone_Web.30.03.23?node-id=0-1',
};
